/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		stripeConfig:{

		},
		paymentBreakdown:{

		},
		documents:{

		},
		download:{

		},
		downloadFile:{

		},
		allAnzsicCodeDivisions:{

		},
		claim:{

		},
		claimProfile:{

		},
		claimState:{
			filterBy:"ClaimStateFilterEnum"
		},
		riskProfile:{

		},
		policy:{

		},
		policies:{

		},
		availableCovers:{

		},
		riskState:{
			filterBy:"RiskStateFilterEnum"
		},
		coverLimitations:{
			kind:"CoverLimitationKind"
		},
		policyUpdateQuote:{

		},
		policyUpdate:{

		},
		policyCancellationQuote:{

		},
		policyRenewalQuote:{

		},
		claims:{

		},
		validateAddressBz:{

		},
		searchAddressBz:{

		},
		riskProfilePaymentAllowed:{

		}
	},
	AdminType:{
		customers:{

		},
		customer:{

		},
		policies:{

		},
		policy:{

		},
		quotes:{
			filterBy:"QuoteFilterBy"
		},
		quote:{

		},
		claims:{
			filterBy:"ClaimFilterBy"
		},
		claim:{

		},
		reports:{

		},
		report:{

		}
	},
	PageSize: `scalar.PageSize` as const,
	DateTime: `scalar.DateTime` as const,
	UUID: `scalar.UUID` as const,
	RiskProfileType:{
		riskStateQuestionSets:{
			filterBy:"RiskStateFilterEnum"
		}
	},
	JSONString: `scalar.JSONString` as const,
	QuotePaymentFrequency: "enum" as const,
	RhetoricalKind: "enum" as const,
	MessageKind: "enum" as const,
	CoverLimitationKind: "enum" as const,
	CoverLimitationLevel: "enum" as const,
	ClaimProfileType:{
		claimStateQuestionSets:{
			filterBy:"ClaimStateFilterEnum"
		}
	},
	PolicyStatus: "enum" as const,
	PolicyCancellationQuoteState: "enum" as const,
	Date: `scalar.Date` as const,
	FeeTypeKind: "enum" as const,
	TransactionStatus: "enum" as const,
	PaymentProfilePaymentGateway: "enum" as const,
	TransactionActionType: "enum" as const,
	TransactionTransactionType: "enum" as const,
	TransactionCurrency: "enum" as const,
	PolicyPeriodKind: "enum" as const,
	ClaimStatusChoices: "enum" as const,
	ClaimStatusTypes: "enum" as const,
	ClaimStateFilterEnum: "enum" as const,
	PaymentGateway: "enum" as const,
	GenericScalar: `scalar.GenericScalar` as const,
	RiskStateFilterEnum: "enum" as const,
	QuoteState: "enum" as const,
	QuoteReferralState: "enum" as const,
	InstallmentKind: "enum" as const,
	QuoteFilterBy: "enum" as const,
	ClaimFilterBy: "enum" as const,
	Mutation:{
		hijackUser:{
			input:"HijackUserInput"
		},
		ssoVerification:{

		},
		ssoAuthenticate:{

		},
		completePayment:{
			input:"CompletePaymentInput"
		},
		confirmQuote:{

		},
		updatePaymentMethod:{
			input:"UpdatePaymentMethodInput"
		},
		refreshUser:{
			input:"RefreshUserInput"
		},
		tokenAuth:{

		},
		kanopiTokenAuth:{

		},
		sendPasswordResetEmail:{

		},
		passwordReset:{

		},
		updateAccount:{

		},
		registerUser:{

		},
		registerPasswordLessUser:{

		},
		updateSsoConfiguration:{
			input:"SsoConfigurationInput"
		},
		dataImport:{
			input:"DataImportInput"
		},
		sortedImport:{
			input:"SortedImportInput"
		},
		startQuote:{
			input:"StartQuoteInput"
		},
		startCancellation:{
			input:"StartPolicyCancellationInput"
		},
		startCover:{
			input:"StartCoverInput"
		},
		startCoverSummary:{
			input:"StartCoverSummaryInput"
		},
		startExposure:{
			input:"StartExposureInput"
		},
		startQuoteSummary:{
			input:"StartQuoteSummaryInput"
		},
		startPolicyholder:{
			input:"StartPolicyHolderInput"
		},
		startKnockouts:{
			input:"StartKnockoutsInput"
		},
		startClaim:{
			input:"StartClaimInput"
		},
		submitClaim:{
			input:"SubmitClaimInput"
		},
		answerEnquiry:{
			input:"AnswerEnquiryInput"
		},
		priceRiskProfile:{
			input:"RiskProfileInput"
		},
		updateRiskCover:{
			input:"UpdateRiskCoverInput"
		},
		updateRiskExposure:{
			input:"UpdateRiskExposureInput"
		},
		updatePolicy:{
			input:"UpdatePolicyInput"
		},
		bindQuotes:{
			input:"BindQuotesInput"
		},
		generateDocuments:{

		},
		generateDocument:{

		},
		startPolicyUpdate:{
			input:"StartPolicyUpdateInput"
		},
		confirmPolicyUpdate:{
			input:"ConfirmPolicyUpdateInput"
		},
		policyUpdateSummary:{
			input:"PolicyUpdateSummaryInput"
		},
		policyCancellationSummary:{
			input:"PolicyCancellationSummaryInput"
		},
		confirmPolicyCancellation:{
			input:"ConfirmPolicyCancellationInput"
		},
		policyRenewalSummary:{
			input:"PolicyRenewalSummaryInput"
		},
		toggleEnabledProducts:{
			input:"ToggleEnabledProductsInput"
		},
		discardRenewalQuote:{
			input:"RenewalQuoteInput"
		},
		createRenewalQuote:{
			input:"CreateRenewalQuoteInput"
		},
		acceptRenewalQuote:{
			input:"RenewalQuoteInput"
		}
	},
	AdminMutation:{
		closeClaim:{
			decision:"ClosedStatus"
		},
		createLazyUser:{
			input:"CreateLazyUserInput"
		},
		createNote:{
			assocObjModel:"NoteAssociationLimit"
		},
		editReferredQuote:{
			input:"EditQuoteInput"
		},
		editPolicyholder:{
			input:"EditPolicyholderInput"
		},
		emailQuote:{
			input:"SendQuoteEmailInput"
		},
		generateReport:{
			input:"GenerateReportInput"
		},
		priceReferredRiskProfile:{

		},
		startAdjustment:{
			input:"StartAdjustmentInput"
		},
		updateQuoteReferralState:{
			referralState:"ReferralState"
		},
		discardRenewalQuote:{
			input:"RenewalQuoteInput"
		}
	},
	ClosedStatus: "enum" as const,
	CreateLazyUserInput:{

	},
	NoteAssociationLimit: "enum" as const,
	EditQuoteInput:{

	},
	EditPolicyholderInput:{

	},
	SendQuoteEmailInput:{

	},
	GenerateReportInput:{

	},
	StartAdjustmentInput:{

	},
	ReferralState: "enum" as const,
	RenewalQuoteInput:{

	},
	HijackUserInput:{

	},
	CompletePaymentInput:{
		metadata:"GenericScalar"
	},
	UpdatePaymentMethodInput:{
		metadata:"GenericScalar"
	},
	RefreshUserInput:{

	},
	ExpectedErrorType: `scalar.ExpectedErrorType` as const,
	SsoConfigurationInput:{

	},
	DataImportInput:{
		riskData:"GenericScalar"
	},
	SortedImportInput:{

	},
	StartQuoteInput:{

	},
	StartPolicyCancellationInput:{

	},
	StartCoverInput:{

	},
	StartCoverSummaryInput:{

	},
	StartExposureInput:{

	},
	StartQuoteSummaryInput:{

	},
	StartPolicyHolderInput:{

	},
	StartKnockoutsInput:{

	},
	StartClaimInput:{

	},
	SubmitClaimInput:{

	},
	AnswerEnquiryInput:{
		answers:"JSONString"
	},
	RiskProfileInput:{

	},
	UpdateRiskCoverInput:{
		answers:"JSONString"
	},
	UpdateRiskExposureInput:{
		answers:"JSONString"
	},
	UpdatePolicyInput:{

	},
	BindQuotesInput:{

	},
	StartPolicyUpdateInput:{

	},
	ConfirmPolicyUpdateInput:{
		startDate:"Date"
	},
	PolicyUpdateSummaryInput:{

	},
	PolicyCancellationSummaryInput:{

	},
	ConfirmPolicyCancellationInput:{

	},
	PolicyRenewalSummaryInput:{

	},
	ToggleEnabledProductsInput:{
		answers:"JSONString"
	},
	CreateRenewalQuoteInput:{

	}
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		stripeConfig:"StripeConfigType",
		paymentBreakdown:"PaymentBreakdownType",
		admin:"AdminType",
		organization:"OrganizationType",
		ssoConfiguration:"SsoConfigurationType",
		organizationFeatureFlags:"OrganizationFeatureFlagsType",
		documents:"GeneratedDocumentType",
		download:"DownloadDocumentType",
		downloadFile:"DownloadFileType",
		allAnzsicCodeDivisions:"AnzsicCodeDivisionType",
		allQuestionSets:"QuestionSetType",
		allQuestions:"QuestionType",
		claim:"ClaimType",
		claimProfile:"ClaimProfileType",
		claimState:"ClaimStateType",
		riskProfile:"RiskProfileType",
		policy:"PolicyType",
		policies:"PolicyType",
		activePolicy:"PolicyType",
		availableCovers:"CoverType",
		riskState:"RiskStateType",
		coverLimitations:"CoverLimitationType",
		policyUpdateQuote:"PolicyUpdateQuoteType",
		policyUpdate:"PolicyUpdateQuoteType",
		policyCancellationQuote:"PolicyCancellationQuoteType",
		policyRenewalQuote:"PolicyRenewalQuoteType",
		loadTheme:"ThemeType",
		cybersourceGenerateContext:"CybersourceContextType",
		claims:"ClaimType",
		validateAddressBz:"ValidateAddressBzType",
		searchAddressBz:"SearchAddressBzType",
		paymentMethod:"PaymentMethodType",
		claimsAllowed:"Boolean",
		riskProfilePaymentAllowed:"Boolean"
	},
	StripeConfigType:{
		account:"String"
	},
	PaymentBreakdownType:{
		premium:"Float",
		surcharge:"Float",
		total:"Float"
	},
	AdminType:{
		customers:"CustomersType",
		customer:"CustomerDetailType",
		policies:"PoliciesType",
		policy:"PolicyType",
		quotes:"QuotesType",
		quote:"QuoteDetailType",
		claims:"ClaimsType",
		claim:"ClaimDetailType",
		products:"ProductType",
		distributionPartners:"DistributionPartnerType",
		reports:"ReportsType",
		report:"ReportType",
		claimsAllowed:"Boolean",
		dataAnalytics:"DataAnalyticsType"
	},
	CustomersType:{
		totalItemCount:"Int",
		page:"Int",
		pageSize:"PageSize",
		pageCount:"Int",
		hasNext:"Boolean",
		hasPrev:"Boolean",
		items:"UserType"
	},
	PageSize: `scalar.PageSize` as const,
	UserType:{
		id:"ID",
		firstName:"String",
		lastName:"String",
		isStaff:"Boolean",
		isActive:"Boolean",
		dateJoined:"DateTime",
		email:"String",
		uuid:"UUID",
		contactEmail:"String",
		contactNumber:"String",
		organization:"OrganizationType",
		isSsoEnabled:"Boolean",
		isLazy:"Boolean",
		isPasswordLess:"Boolean",
		allowCustomerPortalAccess:"Boolean",
		isHijacked:"Boolean",
		latestReferrer:"DistributionPartnerType",
		allowAdminPortalAccess:"Boolean",
		fullName:"String",
		allowUpdatePaymentMethod:"Boolean",
		allowClaim:"Boolean",
		allowReportAccess:"Boolean"
	},
	DateTime: `scalar.DateTime` as const,
	UUID: `scalar.UUID` as const,
	OrganizationType:{
		name:"String",
		key:"String",
		operatingHours:"String",
		emailAddress:"String",
		website:"String",
		disclaimer:"String",
		disclaimerLinks:"DisclaimerLinksType",
		phoneDisplay:"String"
	},
	DisclaimerLinksType:{
		name:"String",
		url:"String"
	},
	DistributionPartnerType:{
		name:"String",
		key:"String",
		allowCustomerPortalAccess:"Boolean"
	},
	CustomerDetailType:{
		details:"UserType",
		quotes:"QuoteType",
		policies:"PolicyType",
		claims:"ClaimType",
		payments:"TransactionType"
	},
	QuoteType:{
		id:"ID",
		riskProfile:"RiskProfileType",
		currentRiskData:"JSONString",
		product:"ProductType",
		covers:"CoverType",
		exposures:"ExposureType",
		limitations:"CoverLimitationType",
		state:"QuoteState",
		referralState:"QuoteReferralState",
		createdTimestamp:"DateTime",
		quotedTimestamp:"DateTime",
		updatedTimestamp:"DateTime",
		startDate:"Date",
		finishDate:"Date",
		expirationDate:"DateTime",
		preTaxPremium:"Float",
		postTaxPremium:"Float",
		unadjustedPostTaxPremium:"Float",
		commission:"Float",
		amountDue:"Float",
		paymentFrequency:"QuotePaymentFrequency",
		pricingOthers:"JSONString",
		messages:"JSONString",
		privateMessages:"JSONString",
		installments:"InstallmentType",
		policyPeriod:"PolicyPeriodType",
		policyUpdates:"PolicyUpdateQuoteType",
		policyRenewals:"PolicyRenewalQuoteType",
		purchaseTransactions:"TransactionType",
		updateTransactions:"TransactionType",
		periodicPrice:"Float",
		userReference:"String",
		documents:"GeneratedDocumentType",
		stateDisplay:"String",
		fees:"FeeSummaryType",
		referralStateDisplay:"String",
		referredQuestionSetKeys:"String",
		isBound:"Boolean",
		daysToExpiry:"Int",
		distributionPartner:"DistributionPartnerType"
	},
	RiskProfileType:{
		id:"ID",
		owner:"UserType",
		riskData:"JSONString",
		quotes:"QuoteType",
		asParentInBundledRiskProfiles:"BundledRiskProfileType",
		paymentFrequency:"QuotePaymentFrequency",
		periodicPrice:"Float",
		availableProducts:"ProductType",
		enabledProducts:"ProductType",
		referredProducts:"ProductType",
		knockoutProducts:"ProductType",
		enabledCovers:"CoverType",
		enabledExposures:"GenericScalar",
		enabledLimitations:"CoverLimitationType",
		state:"String",
		quoteDocumentGenerateStatus:"String",
		policyDocumentGenerateStatus:"String",
		policyPeriods:"PolicyPeriodType",
		data:"JSONString",
		startDate:"String",
		finishDate:"String",
		riskStateQuestionSets:"QuestionSetType"
	},
	JSONString: `scalar.JSONString` as const,
	BundledRiskProfileType:{
		id:"ID",
		riskProfiles:"RiskProfileType"
	},
	ProductType:{
		id:"ID",
		provider:"ProviderType",
		key:"String",
		description:"String",
		covers:"CoverType",
		exposures:"ExposureType",
		policyCancellationQuotes:"PolicyCancellationQuoteType",
		name:"String",
		autoRenewAllowed:"Boolean",
		renewalPeriod:"Int",
		updateAllowed:"Boolean",
		cancellationAllowed:"Boolean",
		cancellationCoolingOffPeriod:"Int",
		claimsAllowed:"Boolean",
		paymentGateway:"PaymentGateway",
		skipPayments:"Boolean",
		autoQuote:"Boolean",
		quoteDisclaimer:"String",
		availableCovers:"CoverType"
	},
	ProviderType:{
		name:"String",
		key:"String",
		logo:"String"
	},
	CoverType:{
		id:"ID",
		product:"ProductType",
		parentCover:"CoverType",
		isDefault:"Boolean",
		exposure:"ExposureType",
		key:"String",
		title:"String",
		description:"String",
		icon:"String",
		subCovers:"CoverType",
		details:"CoverLimitationType",
		coverQuestionSets:"CoverQuestionSetType",
		coverquestionflowSet:"CoverQuestionFlowType",
		coversummaryquestionflowSet:"CoverSummaryQuestionFlowType",
		claimcoverquestionflowSet:"ClaimCoverQuestionFlowType",
		editable:"Boolean"
	},
	ExposureType:{
		id:"ID",
		key:"String",
		type:"String",
		name:"String",
		product:"ProductType",
		limit:"Int",
		userReferencePath:"String",
		icon:"String",
		covers:"CoverType",
		exposureQuestionSets:"ExposureQuestionSetType",
		exposurequestionflowSet:"ExposureQuestionFlowType"
	},
	ExposureQuestionSetType:{
		id:"ID",
		exposure:"ExposureType",
		questionSet:"QuestionSetType",
		exposureItemKey:"String"
	},
	QuestionSetType:{
		id:"ID",
		key:"String",
		title:"String",
		description:"String",
		label:"String",
		help:"String",
		skippable:"Boolean",
		validators:"JSONString",
		order:"Int",
		questions:"QuestionType",
		parentQuestions:"QuestionType",
		rhetoricals:"RhetoricalType",
		enquiries:"EnquiryType",
		coverQuestionSets:"CoverQuestionSetType",
		exposureQuestionSets:"ExposureQuestionSetType"
	},
	QuestionType:{
		id:"ID",
		questionSet:"QuestionSetType",
		label:"String",
		displayLabel:"String",
		title:"String",
		help:"String",
		inputType:"String",
		inputArgs:"JSONString",
		inputForm:"QuestionSetType",
		storagePath:"String",
		default:"JSONString",
		validators:"JSONString",
		order:"Int",
		metadata:"JSONString",
		answers:"AnswerType",
		rhetoricals:"RhetoricalType"
	},
	AnswerType:{
		id:"ID",
		question:"QuestionType",
		value:"JSONString",
		source:"DataProviderType"
	},
	DataProviderType:{
		id:"ID",
		name:"String"
	},
	RhetoricalType:{
		id:"ID",
		name:"String",
		questionSet:"QuestionSetType",
		question:"QuestionType",
		kind:"RhetoricalKind",
		args:"JSONString",
		order:"Int"
	},
	EnquiryType:{
		id:"ID",
		user:"UserType",
		questionFlow:"QuestionFlowType",
		questionSet:"QuestionSetType",
		timestamp:"DateTime"
	},
	QuestionFlowType:{
		"...on ExposureQuestionFlowType": "ExposureQuestionFlowType",
		"...on CoverQuestionFlowType": "CoverQuestionFlowType",
		"...on CoverSummaryQuestionFlowType": "CoverSummaryQuestionFlowType",
		"...on ClaimCoverQuestionFlowType": "ClaimCoverQuestionFlowType",
		"...on QuoteQuestionFlowType": "QuoteQuestionFlowType",
		"...on PolicyHolderQuestionFlowType": "PolicyHolderQuestionFlowType",
		"...on AdjustmentQuestionFlowType": "AdjustmentQuestionFlowType",
		"...on CancellationQuestionFlowType": "CancellationQuestionFlowType",
		"...on QuoteSummaryQuestionFlowType": "QuoteSummaryQuestionFlowType",
		"...on KnockoutQuestionFlowType": "KnockoutQuestionFlowType",
		"...on ClaimQuestionFlowType": "ClaimQuestionFlowType",
		"...on UpdateQuestionFlowType": "UpdateQuestionFlowType",
		"...on LegalQuestionFlowType": "LegalQuestionFlowType",
		"...on PolicyDetailsQuestionFlowType": "PolicyDetailsQuestionFlowType",
		"...on ClaimProductQuestionFlowType": "ClaimProductQuestionFlowType",
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		maxSets:"Int",
		currentSet:"Int",
		currentEnquiry:"EnquiryType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	MessageType:{
		id:"ID",
		kind:"MessageKind",
		content:"String"
	},
	CoverQuestionSetType:{
		id:"ID",
		cover:"CoverType",
		questionSet:"QuestionSetType"
	},
	ExposureQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		exposure:"ExposureType",
		exposureItemKey:"String",
		history:"EnquiryType",
		messages:"MessageType"
	},
	CoverLimitationType:{
		id:"ID",
		cover:"CoverType",
		key:"String",
		kind:"CoverLimitationKind",
		text:"String",
		description:"String",
		order:"Int",
		overrides:"CoverLimitationType",
		level:"CoverLimitationLevel",
		overriddenBy:"CoverLimitationType"
	},
	CoverQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		cover:"CoverType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	CoverSummaryQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		cover:"CoverType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	ClaimCoverQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		claimProfile:"ClaimProfileType",
		cover:"CoverType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	ClaimProfileType:{
		id:"ID",
		owner:"UserType",
		claim:"ClaimType",
		policyPeriods:"PolicyPeriodType",
		products:"ProductType",
		covers:"CoverType",
		claimStateQuestionSets:"QuestionSetType",
		data:"JSONString"
	},
	ClaimType:{
		id:"ID",
		created:"DateTime",
		policyPeriods:"PolicyPeriodType",
		claimNumber:"String",
		claimProfile:"ClaimProfileType",
		status:"ClaimStatusChoices",
		policyNumber:"String",
		statusType:"ClaimStatusTypes",
		statusTypeDisplay:"String",
		decision:"String",
		closedDate:"String"
	},
	PolicyPeriodType:{
		id:"ID",
		policy:"PolicyType",
		quote:"QuoteType",
		boundTimestamp:"DateTime",
		startDate:"Date",
		finishDate:"Date",
		periodNumber:"Int",
		kind:"PolicyPeriodKind",
		renewalQuotes:"PolicyRenewalQuoteType",
		claims:"ClaimType",
		transactions:"TransactionType",
		policyNumber:"String",
		documents:"GeneratedDocumentType",
		latestTransaction:"TransactionType"
	},
	PolicyType:{
		id:"ID",
		policyNumber:"String",
		uuid:"UUID",
		autoRenewEnabled:"Boolean",
		currentPeriod:"PolicyPeriodType",
		status:"PolicyStatus",
		periods:"PolicyPeriodType",
		updateQuotes:"PolicyUpdateQuoteType",
		cancellationQuotes:"PolicyCancellationQuoteType",
		renewalQuotes:"PolicyRenewalQuoteType",
		transactions:"TransactionType",
		documents:"GeneratedDocumentType",
		statusDisplay:"String",
		riskProfile:"RiskProfileType",
		startDate:"String",
		finishDate:"String",
		quote:"QuoteType",
		policyUpdate:"PolicyUpdateQuoteType",
		latestUpdate:"PolicyUpdateQuoteType",
		draftUpdate:"QuoteType",
		policyCancellationQuote:"PolicyCancellationQuoteType",
		updateAllowed:"Boolean",
		cancellationAllowed:"Boolean",
		claimsAllowed:"Boolean",
		latestRenewal:"PolicyRenewalQuoteType",
		latestCancellation:"PolicyCancellationQuoteType",
		isWithinRenewalPeriod:"Boolean",
		isPendingCancellation:"Boolean",
		policyPeriods:"PolicyPeriodType"
	},
	PolicyUpdateQuoteType:{
		id:"ID",
		created:"DateTime",
		modified:"DateTime",
		policy:"PolicyType",
		quote:"QuoteType",
		proRataAmountDue:"Float"
	},
	PolicyCancellationQuoteType:{
		id:"ID",
		policy:"PolicyType",
		state:"PolicyCancellationQuoteState",
		effectiveDate:"Date",
		amountDue:"Float",
		fees:"FeeSummaryType",
		data:"JSONString"
	},
	Date: `scalar.Date` as const,
	FeeSummaryType:{
		breakdown:"FeeType",
		taxes:"Float",
		fees:"Float",
		stampDuty:"Float"
	},
	FeeType:{
		kind:"String",
		amount:"Float",
		feeType:"FeeTypeType"
	},
	FeeTypeType:{
		key:"String",
		label:"String",
		kind:"FeeTypeKind"
	},
	PolicyRenewalQuoteType:{
		id:"ID",
		policy:"PolicyType",
		policyPeriod:"PolicyPeriodType",
		quote:"QuoteType",
		submittedTimestamp:"DateTime",
		canDiscard:"Boolean",
		canAccept:"Boolean"
	},
	TransactionType:{
		id:"ID",
		policyPeriod:"PolicyPeriodType",
		status:"TransactionStatus",
		paymentProfile:"PaymentProfileType",
		paymentGatewayTransactionReference:"String",
		actionType:"TransactionActionType",
		transactionType:"TransactionTransactionType",
		amount:"Float",
		currency:"TransactionCurrency",
		policyNumber:"String",
		statusDisplay:"String",
		transactionTypeDisplay:"String",
		actionTypeDisplay:"String",
		amountWithSurcharge:"Float"
	},
	PaymentProfileType:{
		id:"ID",
		customerReference:"String",
		paymentGateway:"PaymentProfilePaymentGateway"
	},
	GeneratedDocumentType:{
		id:"ID",
		created:"DateTime",
		modified:"DateTime",
		objectId:"Int",
		user:"UserType",
		file:"String",
		name:"String",
		type:"String",
		key:"String",
		url:"String"
	},
	GenericScalar: `scalar.GenericScalar` as const,
	InstallmentType:{
		id:"ID",
		quote:"QuoteType",
		dueDate:"Date",
		inclusivePrice:"Float",
		kind:"InstallmentKind",
		fees:"FeeType"
	},
	PoliciesType:{
		totalItemCount:"Int",
		page:"Int",
		pageSize:"PageSize",
		pageCount:"Int",
		hasNext:"Boolean",
		hasPrev:"Boolean",
		items:"PolicyType"
	},
	QuotesType:{
		totalItemCount:"Int",
		page:"Int",
		pageSize:"PageSize",
		pageCount:"Int",
		hasNext:"Boolean",
		hasPrev:"Boolean",
		items:"QuoteType"
	},
	QuoteDetailType:{
		details:"QuoteType",
		notes:"NoteType"
	},
	NoteType:{
		id:"ID",
		created:"DateTime",
		content:"String",
		author:"UserType"
	},
	ClaimsType:{
		totalItemCount:"Int",
		page:"Int",
		pageSize:"PageSize",
		pageCount:"Int",
		hasNext:"Boolean",
		hasPrev:"Boolean",
		items:"ClaimType"
	},
	ClaimDetailType:{
		details:"ClaimType",
		notes:"NoteType"
	},
	ReportsType:{
		totalItemCount:"Int",
		page:"Int",
		pageSize:"PageSize",
		pageCount:"Int",
		hasNext:"Boolean",
		hasPrev:"Boolean",
		items:"ReportType",
		reportTypes:"GenericScalar"
	},
	ReportType:{
		id:"ID",
		file:"String",
		startDatetime:"DateTime",
		endDatetime:"DateTime",
		name:"String",
		generatedDate:"DateTime",
		reportType:"String",
		url:"String",
		taskStatus:"String"
	},
	DataAnalyticsType:{
		totalQuotes:"DataAnalyticsCardType",
		quotesThisMonth:"DataAnalyticsCardType",
		policiesByStatus:"DataAnalyticsCardType",
		policiesRenewed:"DataAnalyticsCardType",
		totalActivePolicies:"DataAnalyticsCardType",
		totalCustomers:"DataAnalyticsCardType",
		totalClaims:"DataAnalyticsCardType",
		conversionRate:"DataAnalyticsCardType",
		totalGwp:"DataAnalyticsCardType"
	},
	DataAnalyticsCardType:{
		title:"String",
		summaryValue:"String",
		summaryValueType:"String",
		statistics:"DataAnalyticsStatisticType"
	},
	DataAnalyticsStatisticType:{
		label:"String",
		value:"String",
		type:"String"
	},
	SsoConfigurationType:{
		clientIdKey:"String",
		loginUrl:"String",
		logoutUrl:"String",
		callbackUrl:"String",
		successRedirectUrl:"String",
		errorRedirectUrl:"String",
		isClientSecretKeySet:"Boolean"
	},
	OrganizationFeatureFlagsType:{
		enableAzureLogin:"Boolean",
		enableKanopiAuthenticator:"Boolean"
	},
	DownloadDocumentType:{
		url:"String"
	},
	DownloadFileType:{
		url:"String"
	},
	AnzsicCodeDivisionType:{
		id:"ID",
		year:"String",
		code:"String",
		label:"String",
		subdivisions:"AnzsicCodeSubdivisionType"
	},
	AnzsicCodeSubdivisionType:{
		id:"ID",
		division:"AnzsicCodeDivisionType",
		year:"String",
		code:"String",
		label:"String",
		groups:"AnzsicCodeGroupType"
	},
	AnzsicCodeGroupType:{
		id:"ID",
		subdivision:"AnzsicCodeSubdivisionType",
		year:"String",
		code:"String",
		label:"String",
		classes:"AnzsicCodeClassType"
	},
	AnzsicCodeClassType:{
		id:"ID",
		group:"AnzsicCodeGroupType",
		year:"String",
		code:"String",
		label:"String"
	},
	ClaimStateType:{
		claimProfile:"ClaimProfileType",
		questionSets:"QuestionSetType"
	},
	RiskStateType:{
		riskProfile:"RiskProfileType",
		questionSets:"QuestionSetType"
	},
	ThemeType:{
		logo:"LogoType",
		themeOverride:"GenericScalar"
	},
	LogoType:{
		src:"String",
		altText:"String"
	},
	CybersourceContextType:{
		context:"String"
	},
	ValidateAddressBzType:{
		data:"JSONString"
	},
	SearchAddressBzType:{
		data:"JSONString"
	},
	PaymentMethodType:{
		cardNumber:"String",
		cardType:"String",
		expiryDate:"String"
	},
	Mutation:{
		admin:"AdminMutation",
		hijackUser:"TokenType",
		releaseUser:"TokenType",
		ssoVerification:"TokenType",
		ssoAuthenticate:"SsoRedirectType",
		completePayment:"CompletePaymentMutation",
		confirmQuote:"ConfirmQuoteMutation",
		updatePaymentMethod:"UpdatePaymentMethodMutation",
		refreshUser:"TokenType",
		tokenAuth:"ObtainJSONWebToken",
		kanopiTokenAuth:"KanopiTokenAuthentication",
		logoutUser:"LogoutUserMutation",
		sendPasswordResetEmail:"SendPasswordResetEmailMutation",
		passwordReset:"PasswordReset",
		updateAccount:"UpdateAccount",
		registerUser:"RegisterUserMutation",
		registerPasswordLessUser:"RegisterPasswordLessUserMutation",
		updateSsoConfiguration:"SsoConfigurationOutputType",
		dataImport:"DataImportMutation",
		sortedImport:"SortedImportMutation",
		startQuote:"QuoteQuestionFlowType",
		startCancellation:"CancellationQuestionFlowType",
		startCover:"CoverQuestionFlowType",
		startCoverSummary:"CoverSummaryQuestionFlowType",
		startExposure:"ExposureQuestionFlowType",
		startQuoteSummary:"QuoteSummaryQuestionFlowType",
		startPolicyholder:"PolicyHolderQuestionFlowType",
		startKnockouts:"KnockoutQuestionFlowType",
		startClaim:"ClaimQuestionFlowType",
		submitClaim:"ClaimType",
		answerEnquiry:"QuestionFlowType",
		priceRiskProfile:"RiskProfileType",
		updateRiskCover:"RiskProfileType",
		updateRiskExposure:"RiskProfileType",
		updatePolicy:"PolicyType",
		bindQuotes:"PolicyPeriodType",
		generateDocuments:"GenerateDocuments",
		generateDocument:"GenerateDocument",
		startPolicyUpdate:"UpdateQuestionFlowType",
		confirmPolicyUpdate:"PolicyType",
		policyUpdateSummary:"PolicyUpdateSummaryChangesType",
		policyCancellationSummary:"PolicyCancellationQuoteType",
		confirmPolicyCancellation:"PolicyType",
		policyRenewalSummary:"PolicyRenewalSummaryChangesType",
		toggleEnabledProducts:"RiskProfileType",
		discardRenewalQuote:"PolicyRenewalQuoteType",
		createRenewalQuote:"PolicyRenewalQuoteType",
		acceptRenewalQuote:"PolicyRenewalQuoteType"
	},
	AdminMutation:{
		closeClaim:"CloseClaimMutation",
		createLazyUser:"UserType",
		createNote:"NoteType",
		editReferredQuote:"QuoteQuestionFlowType",
		editPolicyholder:"PolicyHolderQuestionFlowType",
		emailQuote:"SendQuoteEmailMutation",
		generateReport:"ReportType",
		priceReferredRiskProfile:"RiskProfileType",
		startAdjustment:"AdjustmentQuestionFlowType",
		updateQuoteReferralState:"UpdateQuoteReferralStateMutation",
		discardRenewalQuote:"AdminDiscardRenewalQuoteMutation"
	},
	CloseClaimMutation:{
		success:"Boolean",
		claim:"ClaimType"
	},
	QuoteQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	PolicyHolderQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	SendQuoteEmailMutation:{
		message:"String"
	},
	AdjustmentQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	UpdateQuoteReferralStateMutation:{
		success:"Boolean",
		quote:"QuoteType",
		note:"NoteType"
	},
	AdminDiscardRenewalQuoteMutation:{
		success:"Boolean",
		renewalQuote:"PolicyRenewalQuoteType"
	},
	TokenType:{
		token:"String",
		user:"UserType"
	},
	SsoRedirectType:{
		url:"String"
	},
	CompletePaymentMutation:{
		paymentSuccess:"Boolean",
		bindSuccess:"Boolean",
		errorMessage:"String"
	},
	ConfirmQuoteMutation:{
		paymentSuccess:"Boolean",
		bindSuccess:"Boolean",
		errorMessage:"String",
		bindMessage:"String"
	},
	UpdatePaymentMethodMutation:{
		success:"Boolean",
		errorMessage:"String"
	},
	ObtainJSONWebToken:{
		token:"String",
		user:"UserType"
	},
	KanopiTokenAuthentication:{
		token:"String",
		user:"UserType"
	},
	LogoutUserMutation:{
		success:"Boolean"
	},
	SendPasswordResetEmailMutation:{
		success:"Boolean",
		errors:"ExpectedErrorType"
	},
	ExpectedErrorType: `scalar.ExpectedErrorType` as const,
	PasswordReset:{
		success:"Boolean",
		errors:"ExpectedErrorType"
	},
	UpdateAccount:{
		success:"Boolean",
		errors:"ExpectedErrorType"
	},
	RegisterUserMutation:{
		success:"Boolean",
		errors:"ExpectedErrorType",
		user:"UserType",
		token:"String"
	},
	RegisterPasswordLessUserMutation:{
		success:"Boolean",
		errors:"ExpectedErrorType",
		user:"UserType",
		token:"String"
	},
	SsoConfigurationOutputType:{
		clientIdKey:"String",
		loginUrl:"String",
		logoutUrl:"String",
		callbackUrl:"String",
		successRedirectUrl:"String",
		errorRedirectUrl:"String"
	},
	DataImportMutation:{
		oneTimeLoginUrl:"String"
	},
	SortedImportMutation:{
		loginUrl:"String",
		user:"SortedUserType"
	},
	SortedUserType:{
		id:"ID",
		sortedId:"String",
		customerNumber:"String",
		user:"UserType",
		email:"String",
		uuid:"UUID",
		workPhone:"String",
		homePhone:"String",
		mobile:"String",
		dateOfBirth:"Date",
		propertyRoles:"SortedUserPropertyRoleType"
	},
	SortedUserPropertyRoleType:{
		id:"ID",
		sortedUser:"SortedUserType",
		serviceNumber:"String",
		riskProfile:"RiskProfileType"
	},
	CancellationQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	QuoteSummaryQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	KnockoutQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	ClaimQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		claimProfile:"ClaimProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	GenerateDocuments:{
		documents:"GeneratedDocumentType"
	},
	GenerateDocument:{
		document:"GeneratedDocumentType"
	},
	UpdateQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		maxSets:"Int",
		currentSet:"Int",
		currentEnquiry:"EnquiryType",
		history:"EnquiryType",
		messages:"MessageType",
		riskProfile:"RiskProfileType"
	},
	PolicyUpdateSummaryChangesType:{
		proRataAmount:"Float",
		oldPeriodicPrice:"Float",
		newPeriodicPrice:"Float",
		surcharge:"Float",
		amountDue:"Float",
		oldPaymentFrequency:"String",
		newPaymentFrequency:"String",
		newStartDate:"String",
		newFinishDate:"String",
		summary:"String"
	},
	PolicyRenewalSummaryChangesType:{
		proRataAmount:"Float",
		oldPeriodicPrice:"Float",
		newPeriodicPrice:"Float",
		surcharge:"Float",
		amountDue:"Float",
		oldPaymentFrequency:"String",
		newPaymentFrequency:"String",
		newStartDate:"String",
		newFinishDate:"String",
		summary:"String"
	},
	LegalQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	PolicyDetailsQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		riskProfile:"RiskProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	},
	ClaimProductQuestionFlowType:{
		id:"ID",
		started:"DateTime",
		finished:"DateTime",
		currentEnquiry:"EnquiryType",
		maxSets:"Int",
		currentSet:"Int",
		claimProfile:"ClaimProfileType",
		history:"EnquiryType",
		messages:"MessageType"
	}
}

export const Ops = {
query: "Query" as const,
	mutation: "Mutation" as const
}
